import useTranslation from 'next-translate/useTranslation';
import { FC } from 'react';

import { Translate } from '@core/constant';
import { EColor, ECurrency } from '@core/type';

import { OptionLabel } from '../../select';
import { SelectTextControl } from './SelectTextControl';
import { SelectCurrencyProps } from './interface-form-select';

export const SelectCurrencyControl: FC<SelectCurrencyProps> = ({
  ...inputProps
}: SelectCurrencyProps): JSX.Element => {
  const { t: tCurrency } = useTranslation(Translate.common.CURRENCY);

  return (
    <SelectTextControl
      {...inputProps}
      width={'100%'}
      name={'currency'}
      options={Object.values(ECurrency).map((currency) => ({
        value: currency,
        label: (
          <OptionLabel currency={currency} color={EColor.PRIMARY}>
            {tCurrency(currency)} - {currency.toUpperCase()}
          </OptionLabel>
        ),
      }))}
    />
  );
};
